import { SLIDE_LAYOUTS } from './slideSchema';
import { getUnitStorage, getUnitStorageJSON, setUnitStorageJSON, storageKey } from '../../../utils/storageByUnit';

const MODELS_KEY = 'arca_modelos_v1';
const SETTINGS_KEY = 'arca_settings_v1';

export const DEFAULT_ARCA_SETTINGS = {
  modoPadrao: 'livre',
  layoutPadrao: SLIDE_LAYOUTS.TITULO_BULLETS,
  tomIa: 'executivo',
  mostrarDicaIlustracao: true,
};

function userSuffix() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.id ? String(user.id) : 'anon';
  } catch {
    return 'anon';
  }
}

function unidadeCodigo() {
  try {
    return localStorage.getItem('unidadeSelecionada') || null;
  } catch {
    return null;
  }
}

function modelsBaseKey() {
  return `${MODELS_KEY}_${userSuffix()}`;
}

function settingsBaseKey() {
  return `${SETTINGS_KEY}_${userSuffix()}`;
}

function legacyModelsKey() {
  return `${MODELS_KEY}_${userSuffix()}`;
}

function legacySettingsKey() {
  return `${SETTINGS_KEY}_${userSuffix()}`;
}

export function loadArcaSettings() {
  const codigo = unidadeCodigo();
  const base = settingsBaseKey();
  try {
    const raw = getUnitStorage(base, codigo, null);
    if (raw) return { ...DEFAULT_ARCA_SETTINGS, ...JSON.parse(raw) };
    const legacy = localStorage.getItem(legacySettingsKey());
    if (legacy) {
      const parsed = { ...DEFAULT_ARCA_SETTINGS, ...JSON.parse(legacy) };
      if (codigo) setUnitStorageJSON(base, codigo, parsed);
      return parsed;
    }
    return { ...DEFAULT_ARCA_SETTINGS };
  } catch {
    return { ...DEFAULT_ARCA_SETTINGS };
  }
}

export function saveArcaSettings(partial) {
  const next = { ...loadArcaSettings(), ...partial };
  const codigo = unidadeCodigo();
  const base = settingsBaseKey();
  if (codigo) setUnitStorageJSON(base, codigo, next);
  else localStorage.setItem(base, JSON.stringify(next));
  return next;
}

export function loadArcaModelos() {
  const codigo = unidadeCodigo();
  const base = modelsBaseKey();
  try {
    const fromUnit = getUnitStorageJSON(base, codigo, null);
    if (fromUnit) return fromUnit;
    const legacy = localStorage.getItem(legacyModelsKey());
    if (legacy) {
      const parsed = JSON.parse(legacy);
      if (codigo) setUnitStorageJSON(base, codigo, parsed);
      return parsed;
    }
    return [];
  } catch {
    return [];
  }
}

function persistModelos(list) {
  const codigo = unidadeCodigo();
  const base = modelsBaseKey();
  if (codigo) setUnitStorageJSON(base, codigo, list);
  else localStorage.setItem(base, JSON.stringify(list));
}

/** @param {{ nome: string, slides: object[] }} payload */
export function saveArcaModelo({ nome, slides }) {
  const list = loadArcaModelos();
  const now = new Date().toISOString();
  const existingIdx = list.findIndex((m) => m.nome === nome);

  const entry = {
    id: existingIdx >= 0 ? list[existingIdx].id : `modelo_${Date.now()}`,
    nome: String(nome || 'Apresentação').trim() || 'Apresentação',
    slides,
    slideCount: slides?.length || 0,
    criadoEm: existingIdx >= 0 ? list[existingIdx].criadoEm : now,
    atualizadoEm: now,
  };

  if (existingIdx >= 0) {
    list[existingIdx] = entry;
  } else {
    list.unshift(entry);
  }

  persistModelos(list);
  return entry;
}

export function deleteArcaModelo(id) {
  const list = loadArcaModelos().filter((m) => m.id !== id);
  persistModelos(list);
  return list;
}

export function getArcaStorageKeys() {
  const codigo = unidadeCodigo();
  return {
    models: storageKey(modelsBaseKey(), codigo),
    settings: storageKey(settingsBaseKey(), codigo),
  };
}
